import { GetProp, TableProps } from "antd";
import { utilityService } from "shared/services";
import { IPipelineDetails } from "sales/models";
import { Link } from "react-router-dom";
import { IOrganization } from "organizations/models";
import { buildOrganizationSectionPath } from "shared/utils/paths";

type ColumnsType<T extends object> = GetProp<TableProps<T>, "columns">;

export const getPipelineDetailsColumns = (organization: IOrganization | undefined): ColumnsType<IPipelineDetails> => [
  {
    title: "",
    dataIndex: "id",
    width: 100,
    fixed: "left",
    render: (value, record, index) => index + 1,
  },
  {
    title: "Project",
    dataIndex: "projectName",
    render: (value, record, index) => (
      <Link to={buildOrganizationSectionPath(organization, `projects/${record.id}`)}>
        {utilityService.truncateField(value)}
      </Link>
    ),
  },
  {
    title: "Revenue",
    dataIndex: "revenue",
    render: (value, record, index) =>
      `$${utilityService.statisticsFormatter(value)}`,
  },
  {
    title: "Commission",
    dataIndex: "commission",
    render: (value, record, index) =>
      `$${utilityService.statisticsFormatter(value)}`,
  },
];
